import { sessionKeys, type StarterChartTemplate } from '@taler/api-client'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useApi } from './api.ts'

export type { StarterChartTemplate }

/** Creates a ledger and hands back its id once the ledger list has refreshed. */
export function useCreateLedger() {
  const api = useApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: { name: string; template: StarterChartTemplate }) =>
      api.session.createLedger(input.name, input.template),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: sessionKeys.ledgers() }),
  })
}
